import angular from 'angular'

import './webregister'

// Current Sale
import './current-sale/sale'
import './current-sale/payment'
import './current-sale/sale-confirmation'
import './current-sale/sale-summary'
import './current-sale/add-customer-to-sale'

import './customer/issue-store-credit'

import { BalancesGiftCardsController } from './gift-cards/balances-gift-cards'
import { BigCommerceGiftCertsController } from './gift-cards/bigcommerce-gift-certs'
import { ActionAddNoteParkSaleController } from './current-sale/action-add-note-park-sale'
import { SelectRegisterController } from './register/select-register'
import { OpenRegisterController } from './register-closure/open-register'
import { CloseRegisterController } from './register-closure/close-register'

angular
  .module('webregister.controllers')
  .controller('BalancesGiftCardsController', BalancesGiftCardsController)
  .controller('BigCommerceGiftCertsController', BigCommerceGiftCertsController)
  .controller(
    'ActionAddNoteParkSaleController',
    ActionAddNoteParkSaleController
  )
  .controller('SelectRegisterController', SelectRegisterController)
  .controller('OpenRegisterController', OpenRegisterController)
  .controller('CloseRegisterController', CloseRegisterController)
